/**
 * Minimal global store for the RAG chat drawer "open" state.
 *
 * No new context provider needed — uses a tiny pub/sub on the module level.
 * The Dashboard "AI Assistant" card calls `openRagChat()`; the RagChatWidget
 * mounted globally in App.js subscribes to the state via `useRagChatOpen()`.
 */
import { useEffect, useState } from 'react';

let _open = false;
const _listeners = new Set();

function _emit() {
  for (const fn of _listeners) fn(_open);
}

export function openRagChat() {
  if (_open) return;
  _open = true;
  _emit();
}

export function closeRagChat() {
  if (!_open) return;
  _open = false;
  _emit();
}

export function useRagChatOpen() {
  const [open, setOpen] = useState(_open);
  useEffect(() => {
    _listeners.add(setOpen);
    return () => { _listeners.delete(setOpen); };
  }, []);
  return [open, openRagChat, closeRagChat];
}
